<template>
  <div class="content-warpper">
    <div class="padding-sm">
      <el-form
          :model="orgForm"
          :rules="rules"
          ref="orgForm"
          label-width="140px"
          class="demo-orgForm"
      >
        <h1 class="apply-title">协调中心申请表</h1>
        <h3 class="apply-item-title padding-bottom">一、申请单位信息</h3>
        <el-form-item v-if="!id" label="初始密码">
          <el-input
              value="123456"
              disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="协调中心类型 " prop="org_type">
          <el-select v-model="orgForm.org_type" filterable placeholder="请选择协调中心类型" style="width: 100%;">
            <el-option
                v-for="item in xtTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构名称" prop="org_name">
          <el-input
              v-model="orgForm.org_name"
              placeholder="请输入申请单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构组织代码" prop="org_code">
          <el-input
              v-model="orgForm.org_code"
              placeholder="请输入机构组织代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="username">
          <el-input
              v-model="orgForm.username"
              placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="phone">
          <el-input
              v-model="orgForm.phone"
              placeholder="请输入联系人手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="flex align-center">
            <el-input
                v-model="orgForm.code"
                placeholder="请输入验证码"
            ></el-input>
            <el-button type="plain" class="margin-left" :disabled="disabledState" @click="sendCode">{{ codeText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="email">
          <el-input
              v-model="orgForm.email"
              placeholder="请输入联系人邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构所在地" prop="region_text">
          <el-cascader
              style="width: 100%;"
              expand-trigger="hover"
              filterable
              placeholder="请选择机构所在地"
              :options="options"
              v-model="orgForm.region_text"
              @change="addressChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
              v-model="orgForm.address"
              placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请单位地理位置">
          <div class="flex align-center justify-between">
            <el-button type="primary" plain style="background: #fff;color: #005eb5;border:1px solid #005eb5" @click="showMap = !showMap" v-show="!showMap">获取地址</el-button>
            <el-autocomplete v-show="showMap"
                             v-model="point"
                             style="width:100%;"
                             popper-class="autoAddressClass"
                             :fetch-suggestions="querySearchAsync"
                             :trigger-on-focus="false"
                             placeholder="请输入详细地址"
                             clearable
                             @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <i class="el-icon-search fl mgr10"/>
                <div style="overflow:hidden;">
                  <div class="title">{{ item.title }}</div>
                  <span class="address ellipsis">{{ item.address }}</span>
                </div>
              </template>
            </el-autocomplete>
            <div v-show="showMap" class="margin-lr">
              {{ orgForm.addrPoint.lng | fixeds }},{{ orgForm.addrPoint.lat | fixeds }}
            </div>
            <el-button type="info" plain v-show="showMap" @click="resetAddress">地址重置</el-button>
          </div>

        </el-form-item>
        <el-form-item v-show="showMap">
          <div id="map-container" style="width:100%;height:300px;"/>
        </el-form-item>
        <el-form-item label="级别类型 " prop="level_id">
          <el-select v-model="orgForm.level_id" filterable placeholder="请选择级别类型" style="width: 100%;">
            <el-option
                v-for="item in levelTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>


<!--        实习协调中心-->
        <div v-if="orgForm.org_type === 3">
          <h3 class="apply-item-title padding-bottom ">二、发展用人单位的计划</h3>
          <el-form-item label-width="50px" label=" " prop="desc_past">
            <p>1.正在或曾经从事的服务于某类群体的项目介绍，如：协会会员服务、俱乐部会员服务、招聘服务等。</p>
            <el-input
                v-model="orgForm.desc_past"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="50px" label=" " prop="desc_plan">
            <p>2.研学旅行指导师项目实习和招聘单位的发展规划。</p>
            <el-input
                v-model="orgForm.desc_plan"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
        </div>
<!--        考场协调中心-->
        <div v-if="orgForm.org_type === 4">
          <h3 class="apply-item-title padding-bottom">二、考试组织</h3>
          <el-form-item label-width="50px" label=" " prop="desc_past">
            <p>1.请简述正在或组织过的考试，包括：考试的名称、规模、运营该种考试的时间、相应的考务团队、使用的考试系统等；</p>
            <el-input
                v-model="orgForm.desc_past"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="50px" label=" " prop="desc_plan">
            <p>2.请简述对研学旅行指导师考试的准备情况，包括：人员、经费、机构、考场渠道、与考场签约计划或签约情况等。</p>
            <el-input
                v-model="orgForm.desc_plan"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
        </div>
<!--        教学协调中心-->
        <div v-if="orgForm.org_type === 5">
          <h3 class="apply-item-title padding-bottom">二、高校发展规划</h3>
          <el-form-item label-width="50px" label=" " prop="desc_past">
            <p>1.正在或曾经的校企合作项目介绍，如：专业共建、联合科研等。</p>
            <el-input
                v-model="orgForm.desc_past"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="50px" label=" " prop="desc_plan">
            <p>2.	研学旅行指导师项目高校发展规划，包括：销售渠道、销售团队、渠道合作规划、高校的合作规划等。</p>
            <el-input
                v-model="orgForm.desc_plan"
                placeholder="请输入"
                type="textarea"
                rows="3"
            ></el-input>
          </el-form-item>
        </div>

        <h3 class="apply-item-title padding-bottom">三、	其他信息</h3>
        <el-form-item label="备注信息" prop="remark" label-width="80px">
          <el-input
              type="textarea"
              v-model="orgForm.remark"
              placeholder="请输入备注信息"
              rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
              style="display:block;background: #005eb5;color: #fff;border:1px solid #005eb5;margin: 0 auto;"
              type="primary"
              class="submit-btn"
              @click="submitForm('orgForm')"
          >提交
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {orgTypes, xtTypes, levelTypes} from "@/tools/utils";
import loadBMap from "@/tools/utils";
import {UPFILE, IMGURL} from "@/config/index";
import {regionData} from "element-china-area-data";
import {sendSms, xtOrgAdd} from "@/api/apply";
// CodeToText
export default {
  name: "organizationAdd",
  data() {
    // 手机号验证
    let checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[0-9]{10}$/;
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("手机号码格式不正确"));
          }
        }
      }, 100);
    };
    return {
      id: '',
      orgTypes: orgTypes(),
      xtTypes: xtTypes(),
      levelTypes: levelTypes(),
      options: regionData,
      map: "", //地图实例
      mk: "", //Marker实例
      locationPoint: null,
      showMap: false,
      point: '',
      orgForm: {
        type: 6,
        org_name: "",
        org_code: "",
        username: "",
        phone: "",
        code:'',
        email: "",
        region_text: "",
        address: "",
        addrPoint: {
          lng: 0,
          lat: 0
        },
        org_type: '',
        level_id: '',
        desc_past:'',
        desc_plan:'',
        remark: '',
      },
      rules: {
        org_name: [{required: true, message: "请输入机构名称", trigger: "blur"}],
        org_code: [{required: true, message: "请输入机构组织代码", trigger: "blur"}],
        username: [{required: true, message: "请输入联系人姓名", trigger: "blur"}],
        phone: [{required: true, validator: checkPhone, trigger: "blur"}],
        code: [{required: true, message: "请输入验证码", trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱地址", trigger: "blur"},
          {type: "email", message: "请输入正确的邮箱地址", trigger: "blur"}],
        region_text: [{required: true, message: "请选择机构所在地", trigger: "change"}],
        address: [{required: true, message: "请输入详细地址", trigger: "blur"}],
        org_type: [{required: true, message: "协调中心类型", trigger: "change"}],
        level_id: [{required: true, message: "级别类型", trigger: "change"}],
        desc_past: [{required: true, message: "请输入", trigger: "blur"}],
        desc_plan: [{required: true, message: "请输入", trigger: "blur"}],
      },
      codeText: '获取验证码', // 验证码文字
      timer: null, // 计时器
      disabledState:true,
      sendState:false
    };
  },
  computed: {
    upUrl() {
      return UPFILE
    },
    imgUrl() {
      return IMGURL
    }
  },
  created() {
    this.id=this.$route.query.id
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap
    // this.initMap();
  },
  methods: {
    //   发送验证码
    async sendCode(){
      if(this.sendState) return
      this.sendState = true
      let _state = await sendSms(this.orgForm.phone)
      if(_state.code === 1002){
        let _second = 60
        this.timer = setInterval(()=>{
          _second--
          this.codeText = `${_second}秒后重新发送`
          if(_second === 0){
            clearInterval(this.timer)
            this.codeText = '重新发送'
            this.timer = null
            this.sendState = false
            this.disabledState = false
          }
        },1000)
      }else{
        this.$message.error(_state.msg)
      }

    },
    //  选择地区后设置地区code码
    addressChange(arr) {
      this.orgForm.region_text = arr;
    },
    //  提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitOrg()
        }else{
          this.$message.error('表单填写有误，请检查确认')
        }
      });
    },
    async submitOrg() {

      let _state = await xtOrgAdd(
          this.orgForm.org_name,
          this.orgForm.org_code,
          this.orgForm.username,
          this.orgForm.phone,
          this.orgForm.code,
          this.orgForm.email,
          this.orgForm.region_text.join(','),
          this.orgForm.address,
          this.orgForm.org_type,
          this.orgForm.level_id,
          this.orgForm.remark,
          this.orgForm.desc_past,
          this.orgForm.desc_plan,
          this.orgForm.addrPoint.lng,
          this.orgForm.addrPoint.lat,
          this.id
      )
      if(_state.code<2000 && _state.code>=1000){
        this.$alert('申请成功，请等待审核', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$refs['orgForm'].resetFields();
            window.location.href='http://www.cxhzfw.org.cn/'
          }
        });
      }

    },

    /************************************/
    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(116.403963, 39.913261);
      this.map.centerAndZoom(point, 16);
      // this.map.enableScrollWheelZoom(true);
      setTimeout(() => {
        this.resetAddress()
      }, 200)

      // 3、设置图像标注并绑定拖拽标注结束后事件
      // this.mk = new BMap.Marker(point, {enableDragging: true});
      // this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
      // 6、浏览器定位
      // this.geolocation()
      // 7、绑定点击地图任意点事件
      // this.map.addEventListener('click', function (e) {
      //   that.getAddrByPoint(e.point)
      // })
    },
    // 获取两点间的距离
    getDistancs(pointA, pointB) {
      return this.map.getDistance(pointA, pointB).toFixed(2);
    },
    // 浏览器定位函数
    geolocation() {
      var that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
          function (res) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              that.getAddrByPoint(res.point);
              that.locationPoint = res.point;
            } else {
              alert("failed" + this.getStatus());
              that.locationPoint = new BMap.Point(113.3324436, 23.1315381);
            }
          },
          {enableHighAccuracy: true}
      );
    },
    // 逆地址解析函数
    getAddrByPoint(point) {
      var that = this;
      var geco = new BMap.Geocoder();
      geco.getLocation(point, function (res) {
        that.mk.setPosition(point);
        that.map.panTo(point);
        that.orgForm.address = res.address;
        that.orgForm.addrPoint = point;
      });
    },
    // 地址搜索
    querySearchAsync(str, cb) {
      var options = {
        onSearchComplete: function (res) {
          var s = [];
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < res.getCurrentNumPois(); i++) {
              s.push(res.getPoi(i));
            }
            console.log(s);
            cb(s);
          } else {
            cb(s);
          }
        }
      };
      var local = new BMap.LocalSearch(this.map, options);
      local.search(str);
    },
    // 选择地址
    handleSelect(item) {
      this.point = item.address + item.title;
      this.orgForm.addrPoint = item.point;
      this.map.clearOverlays();
      this.mk = new BMap.Marker(item.point);
      this.map.addOverlay(this.mk);
      this.map.panTo(item.point);
    },
    // 地址重置
    resetAddress() {
      var point = new BMap.Point(116.403962, 39.915119);
      this.map.clearOverlays();
      this.map.centerAndZoom(point, 16);
      this.point = ''
      this.orgForm.addrPoint.lng = 0
      this.orgForm.addrPoint.lat = 0
      // this.mk = new BMap.Marker(point);
      // this.map.addOverlay(this.mk);
      // this.map.panTo(point);
    },
    /************************************/

    // 返回上一页
    back() {
      this.$router.go(-1);
    },

  },
  watch: {
    //  显示地图
    showMap() {
      this.initMap();
    },
    'orgForm.phone'(){
      if(!this.$tools.checkTel(this.orgForm.phone)){
        this.disabledState = false
      }else{
        this.disabledState = true
      }
    },
    'orgForm.org_type'(){
        this.$refs.orgForm.clearValidate()
    }

  },
  filters: {
    //  过滤经纬度
    fixeds(val) {
      return val.toFixed(6)
    }
  }
};
</script>

<style scoped lang="scss">
.content-warpper {
  .apply-title {
    text-align: center;
    font-size: 32px;
    color: #005eb5;
    padding: 30px 30px 50px;
  }

  .apply-item-title {
    font-size: 18px;
  }
}

.autoAddressClass {
  li {
    i.el-icon-search {
      margin-top: 11px;
    }

    .mgr10 {
      margin-right: 10px;
    }

    .title {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .address {
      line-height: 1;
      font-size: 12px;
      color: #b4b4b4;
      margin-bottom: 5px;
    }
  }
}
</style>
